import React from 'react'
import styled from '@emotion/styled'
import { Box } from 'components'

interface Props {
  text?: string
  status?: string
  width?: number
}

export default function StatusLabel({ text, status, width }: Props) {
  if (!text && !status) return <></>

  return (
    <div>
      <Container vcenter style={{ maxWidth: width }} text={status ?? text}>
        {text ?? status}
      </Container>
    </div>
  )
}

const Container = styled(Box)<{ text }>`
  background-color: ${({ text }) => {
    switch (text?.toLowerCase()) {
      // return '#AAD6FF'
      case 'open':
      case 'draft':
      case 'in_inbound':
      case 'change_pending':
        return '#FBBF66'
      case 'confirmed':
      case 'sent':
      case 'in_transit':
      case 'received':
      case 'completed':
      case 'change_approved':
        return '#74F1A9'
      case 'wait_for_cq':
      case 'change_await':
        return '#eff23f'
      case 'cq_in_progress':
      case 'change_requested':
        return '#ff7bfd'
      case 'receive_await':
      case 'send_await':
      case 'ready_to_receive':
      case 'wait_for_ddt':
      case 'pending':
        return '#82c3ff'
      case 'error':
      case 'cq_error':
      case 'error_pl':
      case 'none':
        return '#FD7575'
      default:
        return '#C4C4C4'
    }
  }};
  color: black;
  font-weight: bold;
  font-size: 16px;
  padding: 0px 12px;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  text-overflow: ellipsis;
`
